import { render, staticRenderFns } from "./CereriOfertaBoltari.vue?vue&type=template&id=468d805d&scoped=true"
import script from "./CereriOfertaBoltari.vue?vue&type=script&lang=js"
export * from "./CereriOfertaBoltari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468d805d",
  null
  
)

export default component.exports